/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAuditLogRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetAuditLogResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getAuditLog = (request: GetAuditLogRequest, options?: CashRequestOptions) => post<GetAuditLogRequest, GetAuditLogResponse>("/2.0/cash/get-audit-log", request, {...options, rejectOnError: true })